import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import { DiagnosisTableBean } from '../../DiagnosesFormTab.types';
import { VisitDiagnosisMarkAsMainEventInterceptor } from '../interceptors/VisitDiagnosisMarkAsMainEventInterceptor';

type MainCellProps = InteractiveTableCellProps<boolean> & {
   readonly visitId: number;
};

export const MainCell = (props: MainCellProps): JSX.Element => {
   const { getCellValue } = useInteractiveTableContext<DiagnosisTableBean>();

   const code = getCellValue('code', props.index);
   const main = getCellValue('main', props.index);
   const markAsMainAvailable = !main;

   return (
      <VisitDiagnosisMarkAsMainEventInterceptor visitId={props.visitId} code={code} enabled={markAsMainAvailable}>
         <InteractiveTable.RadioCell
            testId={'main'}
            name={'main'}
            index={props.index}
            defaultValue={props.defaultValue}
            validationRules={{ required: true }}
         />
      </VisitDiagnosisMarkAsMainEventInterceptor>
   );
};
